import { makeApiCall } from '../core';
import type { ItemEnvelope, ListEnvelope } from '@ruta/shared';

export interface NotificationTemplateChannel {
  subject?: string;
  content: string;
  actionText?: string;
  actionUrl?: string;
  isDefault: boolean;
}

export interface NotificationTemplateResponse {
  notificationType: string;
  name: string;
  description: string;
  isCustomized: boolean;
  enabled?: boolean;
  channels: {
    email?: NotificationTemplateChannel;
    sms?: NotificationTemplateChannel;
  };
  availableVariables: { name: string; description: string }[];
}

export const getNotificationTemplates = async (): Promise<{ templates: NotificationTemplateResponse[] }> => {
  const res = await makeApiCall<ListEnvelope<NotificationTemplateResponse>>(
    'GET',
    '/notification-templates',
  );
  return { templates: res.data };
};

export const updateNotificationTemplate = async (
  notificationType: string,
  data: {
    emailSubject?: string;
    emailContent?: string;
    emailActionText?: string;
    emailActionUrl?: string;
    smsContent?: string;
    enabled?: boolean;
  },
): Promise<{ override: any }> => {
  const res = await makeApiCall<ItemEnvelope<any>>(
    'PATCH',
    `/notification-templates/${notificationType}`,
    data,
  );
  return { override: res.data };
};

export const resetNotificationTemplate = async (notificationType: string): Promise<void> => {
  await makeApiCall<void>('DELETE', `/notification-templates/${notificationType}`);
};
